/**
 * Currency pipeline debug — filter browser console with: ReportCurrency
 * Set window.__REPORT_CURRENCY_DEBUG__ = false to silence.
 */

const PREFIX = '[ReportCurrency]';

export function isReportCurrencyDebugEnabled() {
  if (typeof window !== 'undefined' && window.__REPORT_CURRENCY_DEBUG__ === false) {
    return false;
  }
  return true;
}

export function logReportCurrency(scope, payload) {
  if (!isReportCurrencyDebugEnabled()) return;
  console.log(PREFIX, scope, payload);
}

export function logReportCurrencyTable(scope, rows) {
  if (!isReportCurrencyDebugEnabled()) return;
  console.table(rows);
  console.log(PREFIX, scope);
}
